module.exports = __webpack_public_path__ + "media/images/emblems/Lavizzara-coat_of_arms-baa56271d792546aa08a56803efd0ce8.svg";